import { useMemo, useState } from 'react'

const useSearchPagination = <T>(
    pools: T[] | undefined,
    itemsPerPage = 10,
    // fnFilter: (item, valueDebounce, isEnded?: boolean) => T[],
): {
    currentPage: number
    currentData: T[] | undefined
    handlePagePlus: () => void
    handlePageMinus: () => void
    skip: number
    isDisabled: boolean
} => {
    const [currentPage, setCurrentPage] = useState<number>(1)

    const currentData = useMemo(() => {
        if (pools) {
            return pools
        }
        return undefined
    }, [pools])

    const handlePagePlus = () => {
        if (pools?.length < itemsPerPage) {
            return
        }
        setCurrentPage((prevPage) => prevPage + 1)
    }
    const handlePageMinus = () => {
        if (currentPage === 1) {
            return
        }
        setCurrentPage((prevPage) => prevPage - 1)
    }
    const skip = (currentPage - 1) * itemsPerPage
    const isDisabled = currentData?.length < itemsPerPage
    return {
        currentPage,
        currentData,
        handlePagePlus,
        handlePageMinus,
        skip,
        isDisabled,
    }
}
export default useSearchPagination
